export let userStatuses = [
    { id: 1, cssClass: 'fas fa-check-circle status-background text-success', name: 'general.available'},
    { id: 2, cssClass: 'fas fa-circle status-background text-danger', name: 'general.busy'},
    { id: 3, cssClass: 'fas fa-minus-circle status-background text-danger', name: 'general.doNotDisturb'},
    { id: 4, cssClass: 'fas fa-clock status-background text-warning', name: 'general.beRightBack'},
    { id: 5, cssClass: 'fas fa-clock status-background text-warning', name: 'general.appearAway'},
    { id: 6, cssClass: 'fas fa-times-circle status-background text-dark', name: 'general.offline'},
];
